module.exports = __webpack_public_path__ + "img/eManage-background.2b970dd4.png";